/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import Moment from 'react-moment';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import SiteAddress from 'components/SiteAddress/SiteAddress';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class ReportAssetFaultSuccess extends React.Component<*> {
  render(): React.Fragment {
    const { t, actionDrawerStore, response }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            {response.type ? (
              <React.Fragment>
                <h3>{t('general:assets.owned_assets.messages.fault_report_logged')}</h3>
                <p>{t('general:assets.owned_assets.messages.fault_report_thanks')}</p>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <h3>{t('general:assets.owned_assets.messages.fault_report_sent')}</h3>
                <p>{t('general:assets.owned_assets.messages.fault_report_receipt')}</p>
                {response.contract_number && (
                  <ul>
                    <li>
                      <b>{t('general:contracts.labels.number')}:</b>
                    </li>
                    <li>{response.contract_number}</li>
                  </ul>
                )}
              </React.Fragment>
            )}
            <ul>
              <li>
                <b>{t('general:asset')}:</b>
              </li>
              <li>{response.asset_number}</li>
              <li>{response.manufacturer}</li>
              <li>{response.model}</li>
            </ul>
            <ul>
              <li>
                <b>{t('general:labels.available_for_collection')}:</b>
              </li>
              <li>
                <Moment date={response.collection_date} format="MMMM DD, YYYY" />
              </li>
            </ul>
            <ul>
              <li>
                <b>{t('general:labels.to_be_collected_from')}:</b>
              </li>
              <li>
                {response.location.site ? (
                  <SiteAddress
                    {...response.location.site.address}
                    siteName={response.location.site.name}
                    list={true}
                  />
                ) : typeof response.location === 'string' ? (
                  response.location
                ) : null}
              </li>
            </ul>
            <h5>{t('general:labels.point_of_contact')}:</h5>
            <ul>
              <li>{`${response.contact?.first_name} ${response.contact?.last_name || ''}`}</li>
              <li>{response.contact?.tel}</li>
              <li>{response.contact?.email}</li>
            </ul>
            <h5>{t('general:assets.labels.fault_details')}:</h5>
            <ul>
              <li>{response.fault_details}</li>
            </ul>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
